import { flowRight } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from '../../../common/components/runtime-context';
import ProtectedButton from '../../containers/protected-button';
import { CommentIcon } from '../icons/comment-icon';
import { CommentIconSmall } from '../icons/comment-icon-small';
import { RepliesIcon } from '../icons/replies-icon';
import withTranslate from '../../../common/components/with-translate/with-translate';
import withAuth from '../../hoc/with-auth';
import withDeviceType from '../../hoc/with-device-type';
import styles from './reply-button.scss';
import withFontClassName from '../../hoc/with-font-class-name';
import { getIsRegistrationWithApproval } from '../../selectors/forum-data-selectors';

class ReplyButton extends Component {
  render() {
    const {
      t,
      onClick,
      forPublicUser,
      dataHook,
      type,
      contentFontClassName,
      userName,
      isRegistrationWithApproval,
      isMobile,
    } = this.props;

    const Icon = type === 'reply' ? RepliesIcon : isMobile ? CommentIconSmall : CommentIcon;

    const className = classNames(
      styles.replyButton,
      contentFontClassName,
      'button-hover-color',
      type === 'reply' ? 'forum-icon-fill' : isMobile ? 'forum-icon-fill' : 'forum-icon-stroke',
      type === 'reply'
        ? 'button-hover-fill'
        : isMobile
        ? 'button-hover-fill'
        : 'button-hover-stroke',
    );
    const Component = isRegistrationWithApproval ? ProtectedButton : 'button';

    return (
      <Component
        className={className}
        aria-label={`${t('reply-button.reply-to', { userName })}`}
        onClick={forPublicUser(onClick)}
      >
        <Icon className={classNames(styles.replyIcon)} />
        <span data-hook={dataHook} className={dataHook}>
          {t(`comment.${type}`)}
        </span>
      </Component>
    );
  }
}

ReplyButton.propTypes = {
  dataHook: PropTypes.string,
  mainColor: PropTypes.string,
  t: PropTypes.func,
  forPublicUser: PropTypes.func,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['reply', 'comment', 'answer']).isRequired,
  contentFontClassName: PropTypes.string,
  userName: PropTypes.string,
  isRegistrationWithApproval: PropTypes.bool,
  isMobile: PropTypes.bool,
};

const mapRuntimeToProps = state => ({
  isRegistrationWithApproval: getIsRegistrationWithApproval(state),
});

export default flowRight(
  withFontClassName,
  withTranslate,
  withAuth,
  withDeviceType,
  connect(mapRuntimeToProps),
)(ReplyButton);
